let TAGS: { [tag: string]: string } = {};
export const updateSentryTags = (tags: { [tag: string]: string }) => {
  TAGS = { ...TAGS, ...tags };
};

export const getSentryTags = () => TAGS;

const DEVELOPERS = [
  "sean.stephens@luminorrisk.com",
  "john.karabinos@luminorrisk.com",
  "andrew.hannon@luminorrisk.com",
  "dev@luminorrisk.com",
];

export const isCurrentUserDeveloper = () =>
  TAGS.username !== undefined && DEVELOPERS.includes(TAGS.username);
